import { render, staticRenderFns } from "./CatalogMarket.vue?vue&type=template&id=5eb9f3c0&scoped=true&"
import script from "./CatalogMarket.vue?vue&type=script&lang=js&"
export * from "./CatalogMarket.vue?vue&type=script&lang=js&"
import style0 from "./CatalogMarket.vue?vue&type=style&index=0&id=5eb9f3c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb9f3c0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VBtn,VCard,VDivider,VProgressLinear,VSpacer,VSubheader})
